import { ayurvedicApi, userApi } from "../../../config";

// Fetch all ayurvedic doctors for public page
export const fetchAyurvedicDoctors = async () => {
  
    try {
        console.log("📥 Fetching all ayurvedic doctors...");
        const res = await ayurvedicApi.get("/ayurveda/get-all-doctors");
        console.log("✅ Doctors fetched successfully:", res.data);
        return res.data;
    } catch (err: any) {
        console.error("❌ Error fetching doctors:", err.response?.data || err.message);
        return { success: false, data: [], message: "Failed to fetch doctors" };
    }
}

// Fetch public profile of a specific ayurvedic doctor
export const fetchPublicAyurvedicDoctorProfile = async (doctorId: string) => {
    try {
        const res = await ayurvedicApi.get(`/ayurveda/get-public-profile/${doctorId}`);
        return res.data;
    } catch (err: any) {
        console.error("Error fetching doctor profile:", err);
        return { 
            success: false, 
            message: err.response?.data?.message || "Failed to load doctor profile" 
        };
    }
}

export const fetchPublicConsultations = async (doctorId: string) => {
  try {
    console.log("🔗 API URL:", `${ayurvedicApi.defaults.baseURL}/ayurveda/public/get-doctor-consultations/${doctorId}`);
    const res = await ayurvedicApi.get(
      `/ayurveda/public/get-doctor-consultations/${doctorId}`
    );
    console.log("✅ Consultations fetched:", res.data);
    return res.data;
  } catch (error) {
    console.error("❌ Error fetching consultations:", error);
    throw error;
  }
};
